import CalendarStore from './schema/CalendarStore';
import { createStore } from 'satcheljs';
import { FeedbackType } from './schema/FeedbackFormInfo';
import { ObservableMap } from 'mobx';
import '../orchestrators/calendarSelectionInitiatedOrchestrator';
import '../orchestrators/calendarSurfaceViewOrchestrator';
import '../orchestrators/reloadActiveSurfaceOrchestrator';
import '../mutators/showHideFeedbackFormMutator';
import '../mutators/showHideReportErrorFormMutator';

const calendarStoreData: CalendarStore = {
    calendars: [],
    calendarGroups: [],
    defaultCalendar: null,
    calendarIdToCalendarMapping: new ObservableMap(),
    folderIdMapping: new ObservableMap(),
    feedbackFormInfo: { isFeedbackFormVisible: false, feedbackType: FeedbackType.None },
    calendarOptionsInfo: { calendarOptionsVisible: false },
    calendarSelection: new ObservableMap<string, boolean>(),
};

const getStore = createStore<CalendarStore>('calendar', calendarStoreData);

export const calendarStore = getStore();

export default getStore;
